"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _spriteSymbol = _interopRequireDefault(require("../../resources/images/sprite.symbol.svg"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var Icon = function Icon(_ref) {
  var name = _ref.name;
  return /*#__PURE__*/_react.default.createElement("use", {
    xlinkHref: "".concat(_spriteSymbol.default, "#").concat(name)
  });
};
var _default = exports.default = Icon;